import type { Mutation } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { REQUEST_DATANORM_REBUILD } from './gql/requestDatanormRebuild';

type MutationDataType = Pick<Mutation, 'requestDatanormRebuild'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('requestDatanormRebuild');

export const useRequestDatanormRebuild = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [requestDatanormRebuild, { loading, error, data }] = useMutation<MutationDataType>(REQUEST_DATANORM_REBUILD, {
        onError
    });

    const outgoingRequestDatanormRebuild = useCallback(() => {
        requestDatanormRebuild();
    }, [requestDatanormRebuild]);

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        requestDatanormRebuild: outgoingRequestDatanormRebuild,
        loading,
        response
    };
};
